const SETTINGS = window.MV_CREATE_SETTINGS

// threshold to force the review prompt to appear
export const PROMPT_THRESHOLD = Number(SETTINGS.__PROMPT_THRESHOLD__)
// rating that’s required where it won’t autosubmit, but a name, email, review and review must be added
export const AUTOSUBMIT_THESHOLD = Math.min(Number(SETTINGS.__SUBMIT_THRESHOLD__), PROMPT_THRESHOLD)
export const API_ROOT = SETTINGS.__API_ROOT__
export const OPEN = 'open'
export const CLOSED = 'closed'
export const PENDING = 'pending'
export const ERROR = 'error'
export const DELAY = 2000
export const INITIAL = 'init'
export const SUBMITTING = 'submitting'
export const SUBMITTED = 'submitted'
export const AGGRESSIVE_CTA = SETTINGS.__OPTIONS__.reviews_ctas
